
import {
  ConfirmDocumentResponse,
  DocumentEmbedResponse,
  DocumentMetadataResponse,
  LoadDocumentsResponse,
  LoadRequestedDocumentsResponse,
} from '@ld.consumer-portal/models';
import { EndpointScenarioMap } from './mock.types';

export const documentHistoryScenarios: EndpointScenarioMap<LoadDocumentsResponse> = {
  default: {
    documents: [
      {
        documentId: 'doc-001',
        uniqId: 'doc-001-0',
        documentName: 'Initial Disclosures',
        documentType: 'disclosures',
        uploadDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'completed',
      },
      {
        documentId: 'doc-002',
        uniqId: 'doc-002-1',
        documentName: 'Bank Statement - Chase',
        documentType: 'bank-statement',
        uploadDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'completed',
      },
    ],
  },

  'many-documents': {
    documents: [
      {
        documentId: 'doc-001',
        uniqId: 'doc-001-0',
        documentName: 'Initial Disclosures',
        documentType: 'disclosures',
        uploadDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'completed',
      },
      {
        documentId: 'doc-002',
        uniqId: 'doc-002-1',
        documentName: 'Bank Statement - Chase (Jan)',
        documentType: 'bank-statement',
        uploadDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'completed',
      },
      {
        documentId: 'doc-003',
        uniqId: 'doc-003-2',
        documentName: 'Bank Statement - Chase (Feb)',
        documentType: 'bank-statement',
        uploadDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'completed',
      },
      {
        documentId: 'doc-004',
        uniqId: 'doc-004-3',
        documentName: 'W-2 2023',
        documentType: 'w2',
        uploadDate: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'completed',
      },
      {
        documentId: 'doc-005',
        uniqId: 'doc-005-4',
        documentName: 'W-2 2022',
        documentType: 'w2',
        uploadDate: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'completed',
      },
      {
        documentId: 'doc-006',
        uniqId: 'doc-006-5',
        documentName: 'Pay Stub - January 2024',
        documentType: 'pay-stub',
        uploadDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'completed',
      },
      {
        documentId: 'doc-007',
        uniqId: 'doc-007-6',
        documentName: "Driver's License",
        documentType: 'id',
        uploadDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'completed',
      },
      {
        documentId: 'doc-008',
        uniqId: 'doc-008-7',
        documentName: 'Homeowners Insurance Dec Page',
        documentType: 'insurance',
        uploadDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'pending-review',
      },
    ],
  },

  'no-documents': {
    documents: [],
  },

  'pending-review': {
    documents: [
      {
        documentId: 'doc-001',
        uniqId: 'doc-001-0',
        documentName: 'Bank Statement - Wells Fargo',
        documentType: 'bank-statement',
        uploadDate: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'pending-review',
      },
      {
        documentId: 'doc-002',
        uniqId: 'doc-002-1',
        documentName: 'Pay Stub - February 2024',
        documentType: 'pay-stub',
        uploadDate: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        status: 'pending-review',
      },
    ],
  },
};

export const documentRequestsScenarios: EndpointScenarioMap<LoadRequestedDocumentsResponse> = {
  default: {
    requests: [
      {
        requestId: 'req-001',
        uniqId: 'req-001-0',
        documentType: 'bank-statement',
        documentName: 'Bank Statement (Last 2 Months)',
        description: 'Please provide your most recent 2 months of bank statements for all accounts.',
        status: 'pending',
        requestDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-002',
        uniqId: 'req-002-1',
        documentType: 'pay-stub',
        documentName: 'Pay Stubs (Last 30 Days)',
        description: 'Please provide your most recent pay stubs covering the last 30 days.',
        status: 'pending',
        requestDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      },
    ],
  },

  'many-requests': {
    requests: [
      {
        requestId: 'req-001',
        uniqId: 'req-001-0',
        documentType: 'bank-statement',
        documentName: 'Bank Statement (Last 2 Months)',
        description: 'Please provide your most recent 2 months of bank statements.',
        status: 'pending',
        requestDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-002',
        uniqId: 'req-002-1',
        documentType: 'pay-stub',
        documentName: 'Pay Stubs (Last 30 Days)',
        description: 'Please provide your most recent pay stubs covering the last 30 days.',
        status: 'pending',
        requestDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-003',
        uniqId: 'req-003-2',
        documentType: 'w2',
        documentName: 'W-2 Forms (Last 2 Years)',
        description: 'Please provide W-2 forms for the last 2 tax years.',
        status: 'pending',
        requestDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-004',
        uniqId: 'req-004-3',
        documentType: 'tax-return',
        documentName: 'Tax Returns (Last 2 Years)',
        description: 'Please provide complete tax returns including all schedules.',
        status: 'pending',
        requestDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-005',
        uniqId: 'req-005-4',
        documentType: 'drivers-license',
        documentName: "Driver's License",
        description: "Please provide a clear copy of your valid driver's license.",
        status: 'pending',
        requestDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-006',
        uniqId: 'req-006-5',
        documentType: 'hazard-insurance',
        documentName: 'Homeowners Insurance Declaration Page',
        description: 'Please provide the declaration page from your homeowners insurance policy.',
        status: 'pending',
        requestDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString(),
      },
    ],
  },

  'some-completed': {
    requests: [
      {
        requestId: 'req-001',
        uniqId: 'req-001-0',
        documentType: 'bank-statement',
        documentName: 'Bank Statement',
        status: 'completed',
        requestDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
        submittedDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-002',
        uniqId: 'req-002-1',
        documentType: 'pay-stub',
        documentName: 'Pay Stubs',
        status: 'completed',
        requestDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
        submittedDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-003',
        uniqId: 'req-003-2',
        documentType: 'hazard-insurance',
        documentName: 'Homeowners Insurance',
        description: 'Please provide your insurance declaration page.',
        status: 'pending',
        requestDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
      },
    ],
  },

  'all-completed': {
    requests: [
      {
        requestId: 'req-001',
        uniqId: 'req-001-0',
        documentType: 'bank-statement',
        documentName: 'Bank Statement',
        status: 'completed',
        requestDate: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
        submittedDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-002',
        uniqId: 'req-002-1',
        documentType: 'pay-stub',
        documentName: 'Pay Stubs',
        status: 'completed',
        requestDate: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
        submittedDate: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-003',
        uniqId: 'req-003-2',
        documentType: 'w2',
        documentName: 'W-2 Forms',
        status: 'completed',
        requestDate: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
        submittedDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
      },
    ],
  },

  'no-requests': {
    requests: [],
  },

  overdue: {
    requests: [
      {
        requestId: 'req-001',
        uniqId: 'req-001-0',
        documentType: 'bank-statement',
        documentName: 'Bank Statement (OVERDUE)',
        description: 'Please provide bank statements immediately - this item is past due.',
        status: 'pending',
        requestDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
      },
      {
        requestId: 'req-002',
        uniqId: 'req-002-1',
        documentType: 'pay-stub',
        documentName: 'Pay Stubs',
        description: 'Please provide your most recent pay stubs.',
        status: 'pending',
        requestDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        dueDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(),
      },
    ],
  },
};

export const documentEmbedScenarios: EndpointScenarioMap<DocumentEmbedResponse> = {
  default: {
    documentId: 'doc-001',
    embedUrl: 'https://docs.loandepot.com/embed/doc-001',
  },
  expired: {
    documentId: 'doc-002',
    embedUrl: '',
  },
};

export const confirmDocumentScenarios: EndpointScenarioMap<ConfirmDocumentResponse> = {
  default: {
    documentId: 'doc-001',
    confirmed: true,
  },
  failed: {
    documentId: 'doc-001',
    confirmed: false,
  },
};

export const documentMetadataScenarios: EndpointScenarioMap<DocumentMetadataResponse> = {
  default: {
    documentId: 'doc-001',
    documentName: 'Bank Statement - Chase',
    documentType: 'bank-statement',
    mimeType: 'application/pdf',
    fileSize: 245678,
    uploadDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
  },
  'pending-review': {
    documentId: 'doc-002',
    documentName: 'Pay Stub - February',
    documentType: 'pay-stub',
    mimeType: 'application/pdf',
    fileSize: 123456,
    uploadDate: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
  },
  rejected: {
    documentId: 'doc-003',
    documentName: 'Blurry ID',
    documentType: 'id',
    mimeType: 'image/jpeg',
    fileSize: 567890,
    uploadDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
  },
};
